/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dialog_Text_To_Audio_Listening_Time_HoursInputs */

const en_dialog_text_to_audio_listening_time_hours = /** @type {(inputs: Dialog_Text_To_Audio_Listening_Time_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.count}h`)
};

const es_dialog_text_to_audio_listening_time_hours = /** @type {(inputs: Dialog_Text_To_Audio_Listening_Time_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`~${i?.count} h`)
};

/**
* | output |
* | --- |
* | "~{count}h" |
*
* @param {Dialog_Text_To_Audio_Listening_Time_HoursInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_listening_time_hours = /** @type {((inputs: Dialog_Text_To_Audio_Listening_Time_HoursInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Listening_Time_HoursInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_listening_time_hours(inputs)
	return en_dialog_text_to_audio_listening_time_hours(inputs)
});